import { DocumentResponse } from '../../documents/documentResponse';

export type HandoverPackResponse = {
  handoverPackDocumentSections: Array<HandoverPackDocumentSection>;
};

export type HandoverPackDocumentSection = {
  handoverPackSectionId: number;
  sectionName: string;
  sectionSequence: string;
  handoverPackDocuments: Array<HandoverPackDocument>;
};

export const getHandoverPackDocumentFromDocumentResponse = (document: DocumentResponse): HandoverPackDocument => ({
  documentId: document.documentId,
  documentReference: document.documentReference,
  documentName: document.documentName,
  customerName: document.customerName,
  documentUrl: document.documentUrl,
  documentVersion: document.documentVersion,
  handoverPackSectionSequence: document.handoverPackSectionSequence,
  isAlwaysIncluded: document.isAlwaysIncluded,
  useNuHeatSuppliedHeatPump: document.useNuHeatSuppliedHeatPump,
  useSolar: document.useSolar,
  useUnderfloorHeating: document.useUnderfloorHeating,
  useUserSuppliedHeatPump: document.useUserSuppliedHeatPump,
  useBoiler: document.useBoiler,
  useAnyTechnology: document.useAnyTechnology,
  matchAllParts: document.matchAllParts,
  partNumbers: document.parts.map(part => part.partName),
  secondaryPartNumbers: document.secondaryParts.map(part => part.partName),
  includeInContentsPage: document.includeInContentsPage,
  includeInPrintFolder: document.includeInPrintFolder,
  prePrinted: document.prePrinted,
  neverPrint: document.neverPrint,
});

type HandoverPackDocument = {
  documentId: number;
  documentReference: string;
  documentName: string;
  customerName: string;
  documentUrl: string;
  documentVersion: number | null;
  handoverPackSectionSequence: string;
  isAlwaysIncluded: boolean;
  useNuHeatSuppliedHeatPump: boolean;
  useSolar: boolean;
  useUnderfloorHeating: boolean;
  useUserSuppliedHeatPump: boolean;
  useBoiler: boolean;
  useAnyTechnology: boolean;
  matchAllParts: boolean;
  partNumbers: Array<string>;
  secondaryPartNumbers: Array<string>;
  includeInContentsPage: boolean;
  includeInPrintFolder: boolean;
  prePrinted: boolean;
  neverPrint: boolean;
};
